import React, { useCallback, useEffect, useRef, useState } from 'react';
import DataTable from '@/Components/Common/DataTableWithAutoPagination';
import CommonDataTable, { parseServerPagedResponse } from '../../Common/CommonDataTable';
import { useSelector } from 'react-redux';
import { base64ToString, changeArrayFormat, changeArrayFormat_WithFilter, Decrypt_Id_Name, getShowingDateText, getShowingWithOutTime, stringToBase64 } from '@/Components/Common/Utility';
import { useDispatch } from 'react-redux';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import { get_Report_Approve_Officer_Data, get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import { toastifySuccess } from '@/Components/Common/AlertMsg';
import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { RequiredFieldIncident } from '@/Components/Pages/Utility/Personnel/Validation';
import SelectBox from '@/Components/Common/SelectBox';
import { get_Narrative_Type_Drp_Data } from '@/redux/actions/DropDownsData';
import ReactQuill from 'react-quill';
import CurrentIncMasterReportOld from '@/Components/Pages/Incident/IncidentTab/CurrentIncMasterReportOld';
import PoliceForceIncident from '@/Components/Pages/Incident/IncidentTab/PoliceForceIncident/PoliceForceIncident';
import PoliceForce from '@/Components/Pages/Arrest/ArrestTab/PoliceForce/PoliceForce';

function ReportPendingApprovalOld({ isPreview, reportPendingApprovalEditAllowed = false }) {

  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const useRouterQuery = () => {
    const params = new URLSearchParams(useLocation().search);
    return {
      get: (param) => params.get(param)
    };
  };

  const query = useRouterQuery();
  var IncID = query?.get("IncId");
  var IncNo = query?.get("IncNo");
  if (!IncID) IncID = 0;
  else IncID = parseInt(base64ToString(IncID));
  const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const [clickedRow, setClickedRow] = useState(null);
  const [loginAgencyID, setLoginAgencyID] = useState('');
  const [loginPinID, setLoginPinID] = useState();
  const [editval, setEditval] = useState([]);
  const [narrativeID, setNarrativeID] = useState();
  const [arrestID, setArrestID] = useState();
  const [useOfForceID, setUseOfForceID] = useState("");
  const [caseID, setCaseID] = useState();
  const [queData, setqueData] = useState();
  const [modelStatus, setModelStatus] = useState(false);
  const [WrittenForID, setWrittenForID] = useState();
  const [loder, setLoder] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [reportApprovalStatus, setreportApprovalStatus] = useState(false);
  const [checkapproveStatus, setcheckapproveStatus] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [incomingCadSearch, setIncomingCadSearch] = useState('');
  const lastPaginationRef = useRef({ page: 1, pageSize: 10 });

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) { dispatch(get_LocalStoreData(uniqueId)); }
    }
  }, []);

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) return;
    setLoginAgencyID(localStoreData?.AgencyID);
    setLoginPinID(localStoreData?.PINID);
    dispatch(get_ScreenPermissions_Data("RD103", localStoreData?.AgencyID, localStoreData.PINID));

    setreportApprovalStatus(localStoreData?.ReportApproval);
    setcheckapproveStatus(localStoreData?.IsLevel);
  }, [localStoreData]);

  const columns = [
    {
      name: 'Review',
      cell: row => (
        <div className="text-start">
          <button
            type="button"
            className="btn btn-sm btn-dark w-100 mb-1"
            style={{
              backgroundColor: "#001f3f",
              color: "#fff",
              fontSize: '11px',
              ...(effectiveScreenPermission?.[0]?.Changeok === 1 ? {} : { opacity: 0.65, cursor: 'not-allowed' }),
            }}
            disabled={effectiveScreenPermission?.[0]?.Changeok === 0}
            title={effectiveScreenPermission?.[0]?.Changeok === 1 ? undefined : 'View only — change permission is required to review.'}

            onClick={() => {
              if (effectiveScreenPermission?.[0]?.Changeok === 0) return;
              const UseOfForceID = row?.UseofForceID != null && Number(row.UseofForceID) > 0
                ? row.UseofForceID
                : "";
              GetSingleData(row?.NarrativeID, UseOfForceID);
              setWrittenForID(row?.WrittenForID);
              setNarrativeID(row?.NarrativeID);
              setArrestID(row?.ArrestID);
              setUseOfForceID(UseOfForceID);
              setCaseID(row?.CaseID);
            }}
          >
            Review
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Incident # ', cell: row => {
        return (
          <span
            onClick={() =>
              navigate(`/Inc-Home?IncId=${stringToBase64(row?.IncidentID)}&IncNo=${row?.IncidentNumber}&IncSta=${true}`)
            }
            style={{
              color: '#007bff',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            title="Go to Incident"
          >
            {row?.IncidentNumber}
          </span>
        );
      },
      selector: row => row.IncidentNumber,
      sortable: true,
      wrap: true,
      grow: 0, width: "105px",
    },
    {
      name: 'Arrest # ', cell: row => {
        return (
          <span
            onClick={() => {
              <>
                {
                  row?.ArrestNumber && (
                    navigate(`/Arrest-Home?IncId=${stringToBase64(row?.IncidentID)}&IncNo=${(row?.IncidentNumber)}&IncSta=${true}&ArrestId=${stringToBase64(row?.ArrestID)}&ArrNo=${stringToBase64(row?.ArrestNumber)}`)
                  )}
              </>
            }}
            style={{
              color: '#007bff',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            title="Go to Arrest"
          >
            {row?.ArrestNumber}
          </span>
        );
      }, sortable: true, grow: 0, width: "140px",
    },
    { name: 'Seq #', selector: row => row.sequence, sortable: true, grow: 0, width: '80px', },
    { name: 'Report Source', selector: row => row.Iscase ? "Case Management" : 'Incident', sortable: true, width: '140px' },
    { name: 'Approving Officer/Group', selector: row => row.ApproverName || row.Approve_Officer, sortable: true },
    {
      name: 'Report Type',
      width: "200px",
      selector: row => row.NarrativeDescription,
      sortable: true,

      cell: row => {
        const desc = row.NarrativeDescription?.toLowerCase();

        let backgroundColor = 'transparent';
        let color = 'inherit';

        if (desc === 'initial narrative') {
          backgroundColor = '#fde047'; // yellow-300
          color = 'inherit';
        } else if (desc === 'public narrative') {
          backgroundColor = '#86efac'; // green-300
          color = 'inherit';
        } else if (desc === 'supplementary narrative') {
          backgroundColor = '#bfdbfe'; // blue-200
          color = 'inherit';
        }
        else if (desc === 'press release') {
          backgroundColor = '#f87171'; // red-400
          color = 'inherit';
        }
        else if (desc === 'use of force') {
          backgroundColor = '#007bff';
          color = 'inherit';
        }
        return (
          <span
            style={{
              backgroundColor,
              color,
              padding: '2px 6px',
              borderRadius: '4px',
              display: 'inline-block',
              whiteSpace: "nowrap"

            }}
          >
            {row.NarrativeDescription}
          </span>
        );
      },
    },
    { name: 'Submitted By', selector: row => row.SummittedBy || row.CreateOfficer, sortable: true },
    { name: 'Submitted Date/Time', selector: row => row.CreatedDtTm ? getShowingDateText(row.CreatedDtTm) : '', sortable: true },
    {
      name: 'Due Date',
      selector: row => row.DueDate ? getShowingWithOutTime(row.DueDate) : '',
      sortable: true,
      cell: row => (
        <span style={{ color: 'red' }}>
          {row.DueDate ? getShowingWithOutTime(row.DueDate) : ''}
        </span>
      ),
    },
    {
      name: 'Elapsed Days',
      selector: row => row.ElapsedDay,
      sortable: true,
      cell: row => {
        let color = '';
        if (row.ElapsedDay > row.DueStatus) {
          color = '#FF0000';
        }
        return (
          <span
            style={{
              color,
            }}
          >
            {row.ElapsedDay}
          </span>
        );
      }
    },
    { name: 'Opened By', selector: row => row.OpenedBy, sortable: true },
  ];

  const get_Data_Que_Report = useCallback((OfficerID, agencyId, page, size, incomingCadSearch) => {
    if (OfficerID == null || agencyId == null) {
      return;
    }
    const pageNum = page ?? lastPaginationRef.current.page;
    const pageSizeVal = size ?? lastPaginationRef.current.pageSize;
    lastPaginationRef.current = { page: pageNum, pageSize: pageSizeVal };
    setLoder(false);
    const val = {
      OfficerID,
      AgencyID: agencyId,
      PageNumber: pageNum,
      PageSize: pageSizeVal,
      IncidentNumber: incomingCadSearch,
    };
    fetchPostData('/IncidentNarrativeReport/GetPendingReport', val)
      .then((res) => {
        const { rows, total } = parseServerPagedResponse(res);
        setqueData(rows);
        setTotalRows(total);
        setFilteredData([]);
        setLoder(true);
      })
      .catch(() => {
        setqueData([]);
        setTotalRows(0);
        setLoder(true);
      });
  }, []);

  const onTablePagination = useCallback((page, size) => {
    lastPaginationRef.current = { page, size };
    if (!loginPinID || !loginAgencyID) return;
    get_Data_Que_Report(loginPinID, loginAgencyID, page, size, incomingCadSearch);
  }, [loginPinID, loginAgencyID, get_Data_Que_Report]);

  // Re-fetch (debounced) whenever the search text changes. Skips the first ready
  // run so it doesn't duplicate the table's initial pagination load.
  const isFirstSearchRef = useRef(true);
  useEffect(() => {
    if (!loginPinID || !loginAgencyID) return;
    if (isFirstSearchRef.current) {
      isFirstSearchRef.current = false;
      return;
    }
    const handler = setTimeout(() => {
      get_Data_Que_Report(loginPinID, loginAgencyID, 1, lastPaginationRef.current.pageSize, incomingCadSearch);
    }, 500);
    return () => clearTimeout(handler);
  }, [incomingCadSearch, loginPinID, loginAgencyID, get_Data_Que_Report]);

  const GetSingleData = (NarrativeID, UseOfForceID) => {

    const val = UseOfForceID ? { UseOfForceID } : { NarrativeID, 'OfficerID': loginPinID, 'AgencyID': loginAgencyID, };
    fetchPostData('IncidentNarrativeReport/GetSingleData_NarrativeApprove', val).then((res) => {
      if (res) {
        setEditval(res);
        setModelStatus(true);
      } else {
        setEditval([]);
      }
    })
  }

  const conditionalRowStyles = [
    {
      when: row => row === clickedRow,
      style: {
        backgroundColor: '#001f3fbd',
        color: 'white',
        cursor: 'pointer',
      },
    },
  ];

  const onMasterPropClose = () => {
    navigate('/dashboard-page');
  }

  return (
    <>
      <div className="col-12 que-reports col-sm-12">
        <div className="text-end mt-2 d-flex w-100" style={{ justifyContent: "space-between", alignItems: "center", }}  >
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              {isPreview && (
                <span className="mr-2 ">
                  <svg width="32" height="32" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
                    <rect width="128" height="128" rx="100" fill="#D6ECFF" />
                    <path d="M48 36h44v52H52v8h48V36h-8v44H48z" fill="#E30613" />
                    <rect x="36" y="24" width="56" height="72" rx="4" fill="#0B2F80" />
                    <rect x="48" y="38" width="32" height="6" rx="3" fill="white" />
                    <rect x="48" y="50" width="40" height="6" rx="3" fill="white" />
                    <rect x="48" y="62" width="40" height="6" rx="3" fill="white" />
                    <rect x="48" y="74" width="24" height="6" rx="3" fill="white" />
                  </svg>
                </span>
              )}
              <span className="fw-bold mb-0 " style={{ fontSize: '15px', fontWeight: '700', color: '#334c65' }}>Report Pending Approval</span>
            </div>
          </div>

          {isPreview ? (
            <div className="d-flex align-items-center">
              <div className="position-relative mr-3">
                <input
                  type="text" name="IncidentNumber" id="IncidentNumber"
                  className="form-control py-1 new-input" placeholder="Search......"
                  onChange={(e) => { setIncomingCadSearch(e.target.value); }}
                  autoComplete="off"
                />
              </div>
              <h5 className="mb-0 mr-3" style={{ fontSize: "18px", fontWeight: "600", color: '#334c65' }}>
                {totalRows}
              </h5>
              <Link to="/report-pending-approval">
                <button className="see-all-btn mr-1 see_all-button" style={{ fontSize: "12px", padding: "4px 8px" }}>See All</button>
              </Link>
            </div>
          ) : (
            <button
              className="btn btn-outline-dark mr-3"
              style={{ backgroundColor: "#001f3f", color: "#fff" }}
              onClick={onMasterPropClose}
            >
              Close
            </button>
          )}
        </div>
        <div className="pt-2 que-reports-datatable mt-2">
          <CommonDataTable
            className={isPreview ? 'table-responsive_pastdues datatable-grid' : ''}
            data={queData?.length > 0 ? queData : []}
            columns={columns}
            useAppDefaults
            stickyHeader
            manageServerPagination
            resetPaginationKey={loginAgencyID && loginPinID ? `${loginAgencyID}-${loginPinID}` : ''}
            onPaginationChange={onTablePagination}
            totalRows={totalRows}
            loading={!loder}
            noDataComponent={effectiveScreenPermission?.[0]?.DisplayOK ? 'There are no data to display' : 'You don’t have permission to view data'}
            conditionalRowStyles={conditionalRowStyles}
            onRowClicked={setClickedRow}
            // defaultSortFieldId={8}
            defaultSortAsc={false}
          />
        </div>
        {modelStatus && editval?.length > 0 && (
          <PendingReportReviewModalOld checkapproveStatus={checkapproveStatus} reportApprovalStatus={reportApprovalStatus} editval={editval} get_Data_Que_Report={get_Data_Que_Report} WrittenForID={WrittenForID} narrativeID={narrativeID} loginAgencyID={loginAgencyID} loginPinID={loginPinID} setModelStatus={setModelStatus} useOfForceID={useOfForceID} caseID={caseID} arrestID={arrestID} />
        )}
      </div>
    </>
  )
}

export default ReportPendingApprovalOld

// MODAL : Report Pending Approval > Pending Report Review Modal
export const PendingReportReviewModalOld = (props) => {

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('ReportReview');
  const dispatch = useDispatch();

  const reportApproveOfficer = useSelector((state) => state.Incident.reportApproveOfficer);
  const narrativeTypeDrpData = useSelector((state) => state.DropDown.narrativeTypeDrpData);

  const { editval, narrativeID, loginAgencyID, loginPinID, setModelStatus, checkapproveStatus, reportApprovalStatus, get_Data_Que_Report, WrittenForID, useOfForceID, caseID, arrestID } = props
  const [clickedRow, setClickedRow] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState('Approve');
  const [narrativeData, setnarrativeData] = useState([]);
  const [approvedNarrativeData, setApprovedNarrativeData] = useState([]);
  const [rejectedNarrativeData, setRejectedNarrativeData] = useState([]);
  const [incidentID, setIncidentID] = useState('');
  const [isSaved, setIsSaved] = useState(false);
  const [reportedPinActivity, setreportedPinActivity] = useState(false);
  const [narrativeTypeId, setnarrativeTypeId] = useState(false);
  const [AsOfDate, setAsOfDate] = useState('');
  const [filteredData, setfilteredData] = useState(false);
  const [loginUserGroupList, setLoginUserGroupList] = useState([]);
  const [groupListWithFilter, setGroupListWithFilter] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Individual");
  const [groupList, setGroupList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);
  const [printIncReport, setIncMasterReport] = useState(false);
  const [IncReportCount, setIncReportCount] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [IncidentNo, setIncidentNo] = useState('');
  const [multiSelected, setMultiSelected] = useState({ optionSelected: null });
  const [checkWebWorkFlowStatus, setcheckWebWorkFlowStatus] = useState(false);
  const [reviewStatus, setreviewStatus] = useState(false);
  const [approverRequiredCount, setapproverRequiredCount] = useState();
  const [appRequiredCountCurrentStatus, setappRequiredCountCurrentStatus] = useState();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [triggerUseOfForcePrintCount, setTriggerUseOfForcePrintCount] = useState(0);
  const [triggerArrestPrintCount, setTriggerArrestPrintCount] = useState(0);
  const [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(),
  );
  const [value, setValue] = useState({
    'NameIDNumber': 'Auto Generated', 'NameTypeID': '', 'BusinessTypeID': '', 'SuffixID': '', 'VerifyID': '', 'SexID': '',
    'IsApprove': true, 'IsReject': false, 'Comments': '', 'CommentsDoc': '', 'ApprovalComments': '', 'IsApprovedForward': '',
    'WrittenID': '',
    'IsReview': '',

  })

  const [errors, setErrors] = useState({
    'ReportedByPinError': '', 'AsOfDateError': '', 'NarrativeIDError': '', 'CommentsError': '',
  })

  const rejectColumns = [
    { name: 'Officer', selector: row => row.ApprovingOfficer, sortable: true },
    { name: 'Last Comment', selector: row => row.Comments, sortable: true },
    { name: 'Date', selector: row => row.CreatedDtTm ? getShowingDateText(row.CreatedDtTm) : '', sortable: true },
    { name: 'Status', selector: row => row.status, sortable: true },

  ];

  useEffect(() => {
    if (loginAgencyID) {
      dispatch(get_Report_Approve_Officer_Data(loginAgencyID, loginPinID, narrativeID));
      if (narrativeTypeDrpData?.length === 0) { dispatch(get_Narrative_Type_Drp_Data(loginAgencyID)) }
      get_Group_List(loginAgencyID, loginPinID, narrativeID);
      if (useOfForceID) {
        GetData_ReportWorkLevelCheck_UseOfForce(loginAgencyID, useOfForceID)
      } else {
        GetData_ReportWorkLevelCheck(loginAgencyID, narrativeID)
      }
    }
  }, [loginAgencyID, useOfForceID])

  const get_Group_List = (loginAgencyID, loginPinID, NarrativeID) => {
    const value = { AgencyId: loginAgencyID, PINID: loginPinID, NarrativeID: NarrativeID }
    fetchPostData("Group/GetData_Grouplevel", value).then((res) => {
      if (res) {
        setGroupList(changeArrayFormat(res, 'group', 'Level'))
      }
      else {
        setGroupList();
      }
    })
  }

  useEffect(() => {
    if (!Array.isArray(groupList) || groupList.length === 0) {
      setGroupListWithFilter([]);
      return;
    }
    if (!Array.isArray(loginUserGroupList) || loginUserGroupList.length === 0) {
      setGroupListWithFilter([]);
      return;
    }
    const userLevels = loginUserGroupList
      .map((u) => Number(u.level ?? u.Level))
      .filter((n) => !Number.isNaN(n));
    // Level 0 is not a real tier for this rule — only use positive levels to find the user's top assigned level.
    const userTiersForMin = userLevels.filter((n) => n > 0);
    if (userTiersForMin.length === 0) {
      setGroupListWithFilter([]);
      return;
    }
    // e.g. levels 2 and 3 → use 2; list groups strictly above that tier, excluding level 0 / invalid rows.
    const userTopGroupLevel = Math.min(...userTiersForMin);
    const filtered = groupList.filter((item) => {
      const raw = item?.GroupLevel;
      if (raw == null || raw === '') return false;
      const gl = Number(raw);
      if (!Number.isFinite(gl) || gl <= 0) return false;
      return gl < userTopGroupLevel;
    });
    setGroupListWithFilter(filtered);
  }, [loginUserGroupList, groupList]);

  useEffect(() => {
    if (groupListWithFilter?.GroupID) {
      setValue({
        ...value,
        ['GroupName']: changeArrayFormat_WithFilter(groupListWithFilter, 'group', groupListWithFilter[0]?.GroupID),
        'IncidentId': incidentID, 'CreatedByUserFK': loginPinID,
      });
    }
  }, [groupListWithFilter])

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `.ck-powered-by { display: none !important; }`;
    document.head.appendChild(style);
  }, []);

  const checkId = (id, obj) => {
    const status = obj?.filter((item) => item?.value == id)
    // console.log("🚀 ~ checkId ~ status:", status);?
    return status?.length > 0
  }

  const checkWrittenId = async (id, obj) => {
    const status = await obj?.filter((item) => item?.value == id)

    return status?.length > 0
  }

  useEffect(() => {
    if (editval) {
      setIncidentNo(editval[0]?.IncidentNumber)
      setValue({
        ...value,
        'IncidentID': editval[0]?.IncidentNumber,
        'CADIncidentNumber': editval[0]?.RMSCaseNumber,
        'ReportedBy_Description': editval[0]?.ReportedBy_Description,
        'ReportName': editval[0]?.ReportName,
        'sequence': editval[0]?.sequence,
        'CommentsDoc': editval[0]?.CommentsDoc,
        'Comments': editval[0]?.CommentsDoc,
        'NarrativeReport_Comments': editval[0]?.NarrativeReport_Comments,
        'WrittenID': editval[0]?.WrittenForID,
        'IsReview': editval[0]?.IsReview,
      })
      setappRequiredCountCurrentStatus(editval[0]?.IsApprovedForwardCount);
      setApprovalStatus(editval[0]?.IsReview ? 'ApproveAndReview' : 'Approve');

      setIsSaved(false);
      if (editval[0]?.CommentsDoc?.trim()) {
        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(editval[0]?.CommentsDoc ? editval[0].CommentsDoc?.trim() : <p></p>))));
      }
      setreviewStatus(editval[0]?.IsReview);
      setIncidentID(editval[0]?.IncidentID)
      // setapprovingSuperVisorId(editval[0]?.IncidentID)
      // setCreatedByUserFK(editval[0]?.IncidentID)
      setAsOfDate(editval[0]?.AsOfDate ? getShowingDateText(editval[0]?.AsOfDate) : '');
      setnarrativeTypeId(editval[0]?.NarrativeTypeID)
      setreportedPinActivity(editval[0]?.ReportedByPINActivityID)
      setIsDataReady(true);
    }
    else {
      setValue({
        ...value,
        'IncidentID': '',
        'CADIncidentNumber': '',
        'ReportedBy_Description': '',
        'Comments': '',
        'sequence': '',
        'CommentsDoc': '',
        'WrittenID': ''
      });
    }
  }, [editval])

  const conditionalRowStyles = [
    {
      when: row => row === clickedRow,
      style: {
        backgroundColor: '#cce5ff',
        color: 'black',
      },
    },
  ];

  const tableCustomStyles = {
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#00264d',
        color: '#ffffff',
      },
    },
  };

  useEffect(() => {
    get_Data_Narrative(narrativeID)
  }, [narrativeID])

  useEffect(() => {
    if (loginPinID && loginAgencyID) {
      GetPersonnelGroupDetails(loginPinID, loginAgencyID)
    }
  }, [loginPinID, loginAgencyID])

  const get_Data_Narrative = (NarrativeID) => {
    const val = { 'NarrativeID': NarrativeID }
    fetchPostData('IncidentNarrativeReport/GetData_Narrative', val).then((res) => {
      if (res) {
        setnarrativeData(res);
        const approvedData = res.filter(item => item.IsApprove === true);
        const rejectedData = res.filter(item => item.IsReject === true);

        setApprovedNarrativeData(approvedData);
        setRejectedNarrativeData(rejectedData);

        setfilteredData(res)
      } else {
        setnarrativeData([]);
      }
    })
  }

  const GetPersonnelGroupDetails = (PINID, loginAgencyID) => {
    const val = { 'PINID': PINID, 'AgencyID': loginAgencyID }
    fetchPostData('SecurityGroupUserMembers/GetPersonnelGroupDetails', val).then((res) => {
      if (res) {
        setLoginUserGroupList(res);

      } else {
        setLoginUserGroupList([]);
      }
    })
  }

  // api/SecurityGroupUserMembers/GetPersonnelGroupDetails
  const Add_Type = () => {
    const { IsApprove, IsReject, Comments, CommentsDoc } = value
    const documentAccess = selectedOption === "Individual" ? 'Individual' : 'Group';
    const val = {
      'AgencyID': loginAgencyID,
      'IncidentId': incidentID, 'NarrativeID': narrativeID, 'ApprovingSupervisorType': documentAccess, 'ApprovingSupervisorID': loginPinID, 'IsApprove': value.IsApprove === undefined && value.IsReject === undefined ? true : value.IsApprove, 'CreatedByUserFK': loginPinID, 'IsReject': IsApprove === undefined && IsReject === undefined ? false : IsReject,
      // 'IncidentId': incidentID, 'NarrativeID': narrativeID, 'ApprovingSupervisorType': documentAccess, 'ApprovingSupervisorID': '', 'IsApprove': value.IsApprove === undefined && value.IsReject === undefined ? true : value.IsApprove, 'CreatedByUserFK': loginPinID, 'IsReject': IsReject,
      'CommentsDoc': CommentsDoc,
      "ReportedByPINActivityID": reportedPinActivity,
      "NarrativeTypeID": narrativeTypeId, 'WrittenForID': value?.WrittenID,
      'Comments': Comments,
      'AsOfDate': AsOfDate,
      'ModifiedByUserFK': loginPinID,
      'CaseID': caseID,
    };
    if (!useOfForceID) {
      AddDeleteUpadate('Narrative/Update_Narrative', val).then((res) => {
        Add_Type_Comments()
        get_Data_Narrative(narrativeID)
        const parseData = JSON.parse(res.data);
        toastifySuccess(parseData?.Table[0].Message);
        setIsSaved(true);
        setModelStatus(false);
        reset();
        navigate('/dashboard-page');
      })
    }
    if (useOfForceID) {
      Add_Type_Comments()
      get_Data_Narrative(narrativeID)
      setIsSaved(true);
      setModelStatus(false);
      reset();
      navigate('/dashboard-page');
    }
  }

  const Add_Type_Comments = () => {
    const { IsApprove, IsReject, Comments, CommentsDoc, ApprovalComments, ApprovingSupervisorID, IsApprovedForward, IsReview } = value
    const type = selectedOption === "Individual" ? 'Individual' : 'Group';
    const val = {
      'AgencyID': loginAgencyID,
      'IncidentId': incidentID, 'ApprovingSupervisorType': type, 'ApprovingSupervisorID': ApprovingSupervisorID,
      'IsApprove': reviewStatus ? false : (value.IsApprove === undefined && value.IsReject === undefined) || IsApprovedForward ? true : value.IsApprove,
      //  'IsApprove':  (value.IsApprove === undefined && value.IsReject === undefined) || IsApprovedForward ? true : value.IsApprove,
      'CreatedByUserFK': loginPinID,
      // 'IsApprovedForward': IsApprovedForward,
      'IsApprovedForward': reviewStatus ? false : IsApprovedForward,
      'IsReview': IsReview,
      // 'IsReject': IsApprove === undefined && IsReject === undefined ? false : IsReject,
      'IsReject': IsApprove === undefined && IsReject === undefined || reviewStatus ? false : IsReject,
      'Comments': ApprovalComments,
      'NarrativeID': useOfForceID ? "" : narrativeID,
      'UseofForceID': useOfForceID,
      'CaseID': caseID,
      // 'IncidentId': incidentID, 'NarrativeID': narrativeID, 'ApprovingSupervisorType': type, 'ApprovingSupervisorID': ApprovingSupervisorID, 'IsApprove': IsApprovedForward ? 'true' : IsApprove, 'CreatedByUserFK': loginPinID, 'IsApprovedForward': IsApprovedForward, 'IsReject': IsReject, 'Comments': ApprovalComments,

    };
    AddDeleteUpadate('IncidentNarrativeReport/Insert_IncidentNarrativeReport', val).then((res) => {
      if (loginPinID && loginAgencyID) {
        get_Data_Que_Report(loginPinID, loginAgencyID);
      }
      const parseData = JSON.parse(res.data);
      resets();
    })
  }

  const reset = () => {
    setValue({
      ...value,
      'CommentsDoc': ''
    });
  }

  const resets = () => {
    setValue({
      ...value,
      'ApprovalComments': ''
    });
  }

  const handleRadioChange = (event) => {
    const selectedOptionnew = event.target.value;
    setApprovalStatus(selectedOptionnew);
    setValue(prevState => ({
      ...prevState,
      IsApprove: selectedOptionnew === 'Approve',
      IsReject: selectedOptionnew === 'Reject',
      IsApprovedForward: selectedOptionnew === 'ApproveAndForward',
      IsReview: selectedOptionnew === 'ApproveAndReview',
      ApprovalComments: '',
    }));

    setErrors({ ...errors, ['ApprovalCommentsError']: '', ['CommentsDocumentsError']: '', ['ApprovingOfficerError']: '', ['GroupError']: '' })
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (event) {
      setValue((prevState) => ({ ...prevState, [name]: value, }));
    }
    else {
      setValue((prevState) => ({ ...prevState, [name]: null, }));
    }
  };

  const check_Validation_ErrorApproval = () => {
    if (value.IsApprovedForward || value.IsReview) {
      const ApprovalCommentsErr = RequiredFieldIncident(value?.ApprovalComments);
      const CommentsDocumentsErr = RequiredFieldIncident(value.Comments?.trim());
      const ApprovingOfficerErr = RequiredFieldIncident(value?.ApprovingSupervisorID);

      setErrors(prevValues => {
        return {
          ...prevValues,
          ['ApprovalCommentsError']: ApprovalCommentsErr || prevValues['ApprovalCommentsError'],
          ['CommentsDocumentsError']: CommentsDocumentsErr || prevValues['CommentsDocumentsError'],
          ['ApprovingOfficerError']: ApprovingOfficerErr || prevValues['ApprovingOfficerError'],

        }
      })
    }

    else {
      const ApprovalCommentsErr = RequiredFieldIncident(value.ApprovalComments);
      const CommentsDocumentsErr = RequiredFieldIncident(value.Comments?.trim());
      setErrors(prevValues => {
        return {
          ...prevValues,
          ['ApprovalCommentsError']: ApprovalCommentsErr || prevValues['ApprovalCommentsError'],
          ['CommentsDocumentsError']: CommentsDocumentsErr || prevValues['CommentsDocumentsError'],


        }
      })
    }

  }

  const { ApprovalCommentsError, CommentsDocumentsError, ApprovingOfficerError } = errors

  useEffect(() => {
    if (useOfForceID) {
      if (value.IsApprovedForward || value.IsReview) {
        if (ApprovalCommentsError === 'true' && ApprovingOfficerError === 'true') {
          Add_Type()
          resetserror();
        }
      }
      else {
        if (ApprovalCommentsError === 'true') {
          Add_Type()
          resetserror();
        }
      }
    } else {
      if (value.IsApprovedForward || value.IsReview) {
        if (ApprovalCommentsError === 'true' && CommentsDocumentsError === 'true' && ApprovingOfficerError === 'true') {
          Add_Type()
          resetserror();
        }
      }
      else {
        if (ApprovalCommentsError === 'true' && CommentsDocumentsError === 'true') {
          Add_Type()
          resetserror();
        }
      }
    }
  }, [ApprovalCommentsError, CommentsDocumentsError, ApprovingOfficerError])

  const resetserror = () => {
    setErrors({ ...errors, ['ApprovalCommentsError']: '', ['CommentsDocumentsError']: '', ['ApprovingOfficerError']: '', ['GroupError']: '' })
  }

  const handleRadioChangeArrestForward = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
    setMultiSelected({ optionSelected: [] });
    setErrors({ ...errors, ['ApprovalCommentsError']: '', ['CommentsDocumentsError']: '', ['ApprovingOfficerError']: '', ['GroupError']: '' })
  };

  const Agencychange = (multiSelected) => {
    setMultiSelected({ optionSelected: multiSelected });
    const id = []


    if (multiSelected) {
      multiSelected.map((item, i) => { id.push(item.value); })
      setValue({ ...value, ['ApprovingSupervisorID']: id.toString(), })
    }
  }

  const colourStylesUsers = {
    control: (styles, { isDisabled }) => ({
      ...styles,
      backgroundColor: isDisabled ? '#d3d3d3' : '#ffe2a8',
      fontSize: 14,
      marginTop: 2,
      boxShadow: 'none',
      cursor: isDisabled ? 'not-allowed' : 'default',
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "120px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "120px",
      overflowY: "auto",
    }),
  };

  const GetData_ReportWorkLevelCheck = (loginAgencyID, narrativeID) => {
    const val = { AgencyID: loginAgencyID, NarrativeID: narrativeID };

    fetchPostData('IncidentNarrativeReport/GetData_ReportWorkLevelCheck', val).then(res => {
      if (res && res.length > 0) {

        const workflowData = res[0];
        const canShowApprovalButton = workflowData?.IsMultipleLevel;
        setcheckWebWorkFlowStatus(canShowApprovalButton);
        setapproverRequiredCount(workflowData?.ReportApproverRequired);
      } else {
      }
    });
  };

  const GetData_ReportWorkLevelCheck_UseOfForce = (loginAgencyID, useOfForceID) => {
    const val = { AgencyID: loginAgencyID, UseofForceID: useOfForceID };

    fetchPostData('IncidentNarrativeReport/GetData_ReportWorkLevelCheck', val).then(res => {
      if (res && res.length > 0) {
        const workflowData = res[0];
        const canShowApprovalButton = workflowData?.IsMultipleLevel;
        setcheckWebWorkFlowStatus(canShowApprovalButton);
        setapproverRequiredCount(workflowData?.ReportApproverRequired);
      } else {
      }
    });
  };


  if (!isDataReady) {
    return (
      <div className="custom-modal-wrapper d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }


  return (
    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className={`modal-dialog ${isFullScreen ? 'modal-fullscreen' : 'modal-xl'} modal-dialog-centered`}>
        <div className="modal-content p-2 px-4 approvedReportsModal" style={{ minHeight: useOfForceID ? '280px' : '500px', overflowY: "scroll " }}>
          <div className="d-flex justify-content-between">
            <div className='row mt-1 mb-2'>
              <div className='col-12'>
                <nav className='nav nav-tabs'>
                  <span
                    className={`nav-link nav-links mr-2 ${activeTab === 'ReportReview' ? 'active' : ''}`}
                    style={{ color: activeTab === 'ReportReview' ? 'blue' : 'Red' }}
                    aria-current="page"
                    onClick={() => setActiveTab('ReportReview')}
                  >
                    Report Review
                  </span>
                  |
                  <span
                    className={`nav-link nav-links ml-2 ${activeTab === 'History' ? 'active' : ''}`}
                    style={{ color: activeTab === 'History' ? 'blue' : 'Red' }}
                    aria-current="page"
                    onClick={() => setActiveTab('History')}
                  >
                    History
                  </span>
                </nav>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary mr-2"
                onClick={() => setIsFullScreen(prev => !prev)}
              >
                {isFullScreen ? (
                  <>
                    <i className="fa fa-compress"></i> Normal
                  </>
                ) : (
                  <>
                    <i className="fa fa-expand"></i> Full Screen
                  </>
                )}
              </button>
              <button className="btn-close b-none bg-transparent" onClick={() => { setActiveTab('ReportReview'); setModelStatus(false); resetserror() }} data-dismiss="modal">X</button>
            </div>
          </div>
          {activeTab === 'History' && (
            <div className="mb-3 mt-4">
              <DataTable
                data={filteredData}
                columns={rejectColumns}
                dense
                highlightOnHover
                noHeader
                customStyles={tableCustomStyles}
                conditionalRowStyles={conditionalRowStyles}
                onRowClicked={setClickedRow}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                pagination
              />

            </div>
          )}

          {activeTab === 'ReportReview' && (
            <>
              {/* Report Info */}
              <div className="row mt-1 align-items-center gx-2 gy-2">
                <div className="col-auto px-0" style={{ whiteSpace: 'nowrap', minWidth: '80px' }}>
                  <label className='label-name'>Incident #</label>
                </div>
                <div className='col-sm-2 col-12'>
                  <input type="text" className="form-control" value={value?.IncidentID} readOnly />
                </div>

                <div className="col-auto px-0" style={{ whiteSpace: 'nowrap', minWidth: '90px' }}>
                  <label className='label-name'>Case #</label>
                </div>
                <div className='col-sm-2 col-12'>
                  <input type="text" className="form-control" value={value?.CADIncidentNumber} readOnly />
                </div>

                <div className="col-auto px-0 text-nowrap" style={{ whiteSpace: 'nowrap', minWidth: '116px' }}>
                  <label className='label-name'>Submitting Officer</label>
                </div>
                <div className='col-sm-2 col-12'>
                  <input type="text" className="form-control" value={value?.ReportedBy_Description} readOnly />
                </div>
                {editval[0]?.NarrativeDescription === 'Supplementary Narrative' && (
                  <>
                    <div className="col-auto px-0" style={{ whiteSpace: 'nowrap', minWidth: '50px' }}>
                      <label className='label-name'>Seq #</label>
                    </div>
                    <div className='col-sm-2 col-12'>
                      <input type="text" className="form-control" value={value?.sequence} readOnly />
                    </div>
                  </>
                )}
              </div>

              {!useOfForceID &&
                <div className="row mt-1">
                  <div className="col-12 col-md-12 col-lg-12 px-0 pl-0">
                    <ReactQuill
                      className={`editor-class ${reviewStatus === true ? 'readonly' : ''}`}

                      value={value.Comments}
                      // onChange={(value, delta, source, editor) => {
                      //   const text = editor?.getText();
                      //   setValue((prevValue) => ({
                      //     ...prevValue,
                      //     Comments: text,
                      //     CommentsDoc: value,
                      //   }));

                      // }}
                      modules={{
                        history: { delay: 200, maxStack: 500, userOnly: true },
                        toolbar: [
                          [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                          [{ 'size': ['small', 'medium', 'large', 'huge'] }],  // Font 
                          // size options 
                          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                          [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
                          ['bold', 'italic', 'underline'],
                          // ['link', 'image'],
                          [{ 'color': [] }, { 'background': [] }],  // Text color and 
                          // background color 
                          ['blockquote'],
                          ['spell-checker'],  // spell checker
                          ['undo', 'redo'],
                        ],
                      }}
                      formats={['undo', 'redo', "header", "bold", "italic", "underline", "size", "background", "strike", 'align', "blockquote", 'list', "bullet", "indent", "code-block", "spell-checker", "color",
                        // "link", 
                        // "image", 
                      ]}
                      editorProps={{ spellCheck: true }}
                      theme="snow"
                      placeholder="Write something..."
                      style={{
                        // minHeight: isFullScreen ? '55vh' : '200px',
                        // maxHeight: isFullScreen ? '55vh' : '210px',
                        overflowY: 'auto',
                      }}
                    />
                  </div>

                </div>
              }
              <div className='row mt-1'>
                {
                  (reviewStatus === false || reviewStatus === 'false') && (
                    <>
                      <div className='col-md-2'>
                        {
                          !(checkWebWorkFlowStatus
                            && (Number(appRequiredCountCurrentStatus) < Number(approverRequiredCount))
                            && groupListWithFilter?.length > 0) ? (
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                value="Approve"
                                name="flexRadioDefault"
                                checked={value.IsApprove}
                                onChange={handleRadioChange}
                              />
                              <label className="form-check-label " >
                                Approve
                              </label>
                            </div>
                          ) : (
                            <></>
                          )
                        }
                      </div>
                      <div className='col-md-2'>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="Reject"
                            name="flexRadioDefault"
                            checked={value.IsReject}
                            onChange={handleRadioChange}
                          />
                          <label className="form-check-label ">
                            Reject
                          </label>
                        </div>
                      </div>
                      <div className='col-md-2'>
                        {!!(checkWebWorkFlowStatus
                          && (Number(appRequiredCountCurrentStatus) < Number(approverRequiredCount))
                          && groupListWithFilter?.length > 0) ? (
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              value="ApproveAndForward"
                              name="flexRadioDefault"
                              checked={value.IsApprovedForward}
                              onChange={handleRadioChange}
                            />
                            <label className="form-check-label ">
                              Approve and Forward
                            </label>
                          </div>
                        ) : null}
                      </div>
                    </>
                  )
                }
                {/* <div className='col-md-2'>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="ApproveAndReview"
                      name="flexRadioDefault"
                      checked={value.IsReview}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label ">
                      Review
                    </label>
                  </div>
                </div> */}
              </div>
              <div className="row ">
                <div className="col-12 col-md-12 col-lg-12">
                  <div className="row ">
                    {(approvalStatus === 'ApproveAndForward' || approvalStatus === 'ApproveAndReview' && reviewStatus === false) && (
                      <>
                        <div className="col-6 col-md-6 col-lg-3 mt-2 pt-1">
                          <div className="form-check ml-2">
                            <input
                              type="radio"
                              name="approverType"
                              value="Individual"
                              className="form-check-input"
                              checked={selectedOption === "Individual"}
                              onChange={handleRadioChangeArrestForward}
                            />
                            <label className="form-check-label" htmlFor="Individual">
                              Individual
                            </label>
                          </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-3 mt-2 pt-1">
                          <div className="form-check ml-2">
                            <input
                              type="radio"
                              name="approverType"
                              value="Group"
                              className="form-check-input"
                              checked={selectedOption === "Group"}
                              onChange={handleRadioChangeArrestForward}
                            />
                            <label className="form-check-label" htmlFor="Group">
                              Group
                            </label>
                          </div>
                        </div>
                      </>
                    )}

                    {(approvalStatus?.trim() === "ApproveAndForward" || approvalStatus?.trim() === "ApproveAndReview" && reviewStatus === false) && (
                      <>
                        {selectedOption === "Individual" ? (
                          <>
                            <div className="col-2 col-md-2 col-lg-2 mt-3 pt-2">
                              <span className="label-name">
                                Report Approver
                                {errors.ApprovingOfficerError !== 'true' && (
                                  <p style={{ color: "red", fontSize: "13px", margin: "0px", padding: "0px", fontWeight: "400" }}>
                                    {errors.ApprovingOfficerError}
                                  </p>
                                )}
                              </span>
                            </div>
                            <div className="col-4 col-md-12 col-lg-4 dropdown__box">
                              <SelectBox
                                className="custom-multiselect"
                                classNamePrefix="custom"
                                options={reportApproveOfficer}
                                isMulti
                                required
                                menuPlacement="bottom"
                                styles={colourStylesUsers}
                                allowSelectAll={reportApproveOfficer.length > 0 ? true : false}
                                closeMenuOnSelect={false}
                                onChange={Agencychange}
                                value={multiSelected.optionSelected}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-2 col-md-2 col-lg-2 mt-3 pt-2">
                              <span className="label-name">
                                Approval Group
                                {errors.ApprovingOfficerError !== 'true' && (
                                  <p style={{ color: "red", fontSize: "13px", margin: "0px", padding: "0px", fontWeight: "400" }}>
                                    {errors.ApprovingOfficerError}
                                  </p>
                                )}
                              </span>
                            </div>
                            <div className="col-4 col-md-12 col-lg-4 dropdown__box">
                              <SelectBox
                                className="custom-multiselect"
                                classNamePrefix="custom"
                                options={groupListWithFilter}
                                menuPlacement="bottom"
                                isMulti
                                styles={colourStylesUsers}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={true}
                                allowSelectAll={groupListWithFilter.length > 0 ? true : false}
                                onChange={Agencychange}
                                value={multiSelected.optionSelected}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Approve Section */}
              {(approvalStatus === 'Approve' || approvalStatus === 'ApproveAndForward' || approvalStatus === 'ApproveAndReview' && reviewStatus === false) && (
                <>
                  <div className="row g-3 ">
                    <div className="col-md-6">
                      <label className="fw-bold">Previous Comment</label>

                      <div className="form-control bg-light" style={{ minHeight: '56px' }}>
                        {value?.NarrativeReport_Comments}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="fw-bold">Enter Approval Comments Here</label>
                      <textarea
                        className="form-control"
                        style={{ minHeight: '50px', background: '#ffe2a8' }}
                        placeholder="Enter Approval Comments"
                        name="ApprovalComments"
                        value={value?.ApprovalComments}

                        onChange={(e) => { handleChange(e) }}
                      />
                      {errors.ApprovalCommentsError !== 'true' ? (
                        <p style={{ color: 'red', fontSize: '13px', margin: '0px', padding: '0px', fontWeight: "400" }}>{errors.ApprovalCommentsError}</p>
                      ) : null}
                    </div>
                  </div>
                </>
              )}

              {/* Reject Section */}
              {approvalStatus === 'Reject' && (
                <>
                  <div className="row g-3 ">
                    <div className="col-md-6">
                      <label className="fw-bold">Previous Reason for Rejection</label>
                      <div className="form-control bg-light" style={{ minHeight: '56px' }}>
                        {value?.NarrativeReport_Comments}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="fw-bold">Enter Reason for Rejection</label>
                      <textarea
                        className="form-control"
                        style={{ minHeight: '50px', background: '#fff3cd' }} // light yellow
                        placeholder="Enter Reason for Rejection"
                        name="ApprovalComments"
                        value={value.ApprovalComments}
                        onChange={(e) => { handleChange(e) }}
                      />
                      {errors.ApprovalCommentsError !== 'true' ? (
                        <p style={{ color: 'red', fontSize: '13px', margin: '0px', padding: '0px', fontWeight: "400" }}>{errors.ApprovalCommentsError}</p>
                      ) : null}
                    </div>
                  </div>
                </>
              )}
              <div className="d-flex justify-content-end mt-4">
                {!isSaved && (
                  <button className="btn btn-primary " disabled={editval[0]?.IsReview} style={{ backgroundColor: "#001f3f", color: "#fff" }} onClick={(e) => { check_Validation_ErrorApproval(); }}>Save</button>
                )}
                <button
                  type="button"
                  className="btn btn-sm btn-success ml-2 "
                  {...(!useOfForceID && !arrestID && {
                    'data-toggle': 'modal',
                    'data-target': '#CurrentIncidentReport'
                  })}
                  onClick={() => {
                    if (arrestID) {
                      setTriggerArrestPrintCount((c) => c + 1);
                    } else if (useOfForceID) {
                      setTriggerUseOfForcePrintCount((c) => c + 1);
                    } else {
                      setShowModal(true);
                      setIncMasterReport(true);
                      setIncReportCount(IncReportCount + 1);
                    }
                  }}
                >
                  Print <i className="fa fa-print"></i>
                </button>
              </div>
            </>
          )}

          {/* Master Incident Report Print */}
          <CurrentIncMasterReportOld
            incNumber={IncidentNo}
            {...{
              printIncReport,
              setIncMasterReport,
              showModal,
              setShowModal,
              IncReportCount,
              setIncReportCount,
            }}
          />

          {/* Incident Use Of Force Print*/}
          {!!(useOfForceID && !arrestID) ? (
            <div style={{ display: 'none' }}>
              <PoliceForceIncident
                triggerPrintCount={triggerUseOfForcePrintCount}
                externalIncidentID={editval[0]?.IncidentID}
                externalUseOfForceID={useOfForceID}
              />
            </div>
          ) : null}

          {/* Arrest Use Of Force  Print*/}
          {!!arrestID ? (
            <div style={{ display: 'none' }}>
              <PoliceForce
                triggerPrintCount={triggerArrestPrintCount}
                externalArrestID={arrestID}
                externalIncidentID={editval[0]?.IncidentID}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
